import { useEffect, useRef } from "react";
import api, { isSuccess } from "util/api";
import {
  ApiCompletedTodoCreateBulkParams,
  apiCompletedTodoCreateBulkPath,
  ApiCompletedTodoCreateBulkResponse,
} from "apiRoutes/apiCompletedTodoRoutes";
import useAuth from "util/useAuth/useAuth";
import useTodosReducer from "./useTodosReducer";

/**
 * Clear all temp todos when a user becomes logged in and save them to the server
 */
export default function usePersistSignedOutCompletedTodosOnLoggin([
  state,
  dispatch,
]: ReturnType<typeof useTodosReducer>) {
  const auth = useAuth();
  const triedOnce = useRef(false); // only fetch it once

  useEffect(() => {
    if (triedOnce.current) {
      return;
    }

    if (auth.type !== "loggedin") {
      return;
    }

    triedOnce.current = true;

    const todoIds = Array.from(state.completedTodos.signedOut);

    if (todoIds.length <= 0) {
      return;
    }

    const fn = async () => {
      const response = await api<
        ApiCompletedTodoCreateBulkResponse,
        ApiCompletedTodoCreateBulkParams
      >(apiCompletedTodoCreateBulkPath, "POST", {
        body: { todo_ids: todoIds },
      });
      if (!isSuccess(response)) {
        return;
      }

      dispatch({
        type: "MOVE_SIGNED_OUT_COMPLETED_TODOS_TO_SIGNED_IN",
        payload: { completedTodos: response.response },
      });
    };

    fn();
  }, [auth.type, dispatch, state.completedTodos.signedOut]);
}
